// extracted by mini-css-extract-plugin
export default {"container":"Workspace_container__djwq-","foldersRow":"Workspace_foldersRow__DCXys","addFolderButton":"Workspace_addFolderButton__2CTkK","folders":"Workspace_folders__5Kogx"};